import { render, staticRenderFns } from "./DcApprovalComplete.vue?vue&type=template&id=64aec552&scoped=true"
import script from "./DcApprovalComplete.vue?vue&type=script&lang=js"
export * from "./DcApprovalComplete.vue?vue&type=script&lang=js"
import style0 from "./DcApprovalComplete.vue?vue&type=style&index=0&id=64aec552&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64aec552",
  null
  
)

export default component.exports